import React, {useState} from "react";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import {red} from "@material-ui/core/colors";
import TextField from "@material-ui/core/TextField/TextField";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    container: {
        padding: 10,
        borderRadius: 4,
        background: 'rgb(246 246 246)'
    },
    refTextContainer: {
        margin: '0px 0px 10px 0px',
        display: 'flex',
        position: 'relative'
    },
    refAuthor: {
        fontSize: '0.9rem',
        background: 'rgb(229 229 229)',
        padding: '10px 20px 10px 5px',
        position: 'relative'
    },
    refText: {fontSize: '0.9rem'}

}));

const CommentInput = ({refComment, sendMessage, inputRef, removeReplying}) => {
    const [comment, setComment] = useState('');
    const classes = useStyles();

    async function sendComment() {
        if (!comment.length) return;

        await sendMessage(comment);
        setComment('')
    }

    function onChange(e) {
        setComment(e.target.value)
    }

    async function onKeyDown(e) {
        if (e.ctrlKey && e.key === 'Enter') {
            await sendComment();
        }
    }

    return (
        <div
            id={'comments-container'}
            className={classes.container}
        >
            {refComment.text && (
                <div className={classes.refTextContainer}>
                    <Typography
                        color={"textPrimary"}
                        className={classes.refAuthor}
                        component={'span'}
                    >
                        <Typography color={"textSecondary"}
                                    className={classes.refText}
                                    component={'span'}
                        >{refComment.author.name}: </Typography> {refComment.text}
                        <div
                            style={{
                                position: 'absolute',
                                top: -9,
                                right: -9
                            }}
                        >
                            <IconButton style={{padding: 0}} size={"small"}
                                        onClick={removeReplying}
                            >
                                <Icon fontSize={"small"}>
                                    backspace
                                </Icon>
                            </IconButton>
                        </div>
                    </Typography>
                </div>
            )}
            <TextField
                type={'text'}
                inputRef={inputRef}
                fullWidth
                value={comment}
                multiline
                onKeyDown={onKeyDown}
                onChange={onChange}
                placeholder={'Write your comment...'}
                rowsMax={6}
                variant={"outlined"}
                InputProps={{
                    endAdornment: (
                        <IconButton onClick={sendComment} disabled={!comment.length}>
                            <Icon>
                                send
                            </Icon>
                        </IconButton>
                    )
                }}
            />
        </div>
    )
};

export default CommentInput
